import { render } from "./InvoiceItems.vue?vue&type=template&id=65d30c7f"
import script from "./InvoiceItems.vue?vue&type=script&lang=js"
export * from "./InvoiceItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__